import FormikTextInput from "@components/FormikTextInput";
import { Formik } from "formik";
import { useState } from "react";
import { ReactConfirmAlertProps } from "react-confirm-alert";

const InsertNameAndPhone = (props: { callback: (customer_name: string, customer_phone: string) => void; onClose: () => void }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const handleSubmit = async () => {
    const phoneRegex = /\([1-9]\d\)9\d{4}-\d{4}/g;
    if (!name || !phone) {
      setError("Preencha todos os campos");
      return;
    } else if (!phoneRegex.test(phone)) {
      setError("Telefone inválido");
      return;
    }
    setError("");
    props.callback(name, phone);
    props.onClose();
  };

  return (
    <div
      className="bg-white p-4"
      style={{
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
        maxWidth: "400px",
      }}
    >
      <Formik initialValues={{ name: "", phone: "" }} onSubmit={handleSubmit}>
        {() => (
          <>
            <h1 className="fw-light" style={{ color: "#666666" }}>
              Atenção
            </h1>
            <p>Informe seu nome e telefone para continuar.</p>
            <div className="flex flex-col justify-content-between">
              <div className="mt-2">
                <div className="flex flex-col">
                  <FormikTextInput
                    className="mb-2"
                    name="customer_name"
                    label={"Nome"}
                    mask={""}
                    onChange={(e) => {
                      setName(e?.target?.value);
                    }}
                    required
                  />
                </div>

                <FormikTextInput
                  name="customer_phone"
                  className="mb-2"
                  label={"Telefone"}
                  mask="(99)99999-9999"
                  onChange={(e) => {
                    setPhone(e?.target?.value);
                  }}
                  required
                />
              </div>
              <div>
                <span className="text-danger">{error}</span>
              </div>
              <div
                className="mt-2 p-2 text-white fw-light flex text-center"
                style={{
                  backgroundColor: "#333333",
                  borderRadius: "8px",
                }}
                onClick={handleSubmit}
              >
                Enviar
              </div>
            </div>
          </>
        )}
      </Formik>
    </div>
  );
};

export function reactConfirmInsertNameAndPhone(functionToDispatch: (customer_name: string, customer_phone: string) => void): ReactConfirmAlertProps {
  return {
    closeOnClickOutside: false,
    customUI: (props) => <InsertNameAndPhone callback={functionToDispatch} {...props} />,
  };
}
